import { render, staticRenderFns } from "./PatientAppointmentNotFound.vue?vue&type=template&id=60579d9c&scoped=true"
import script from "./PatientAppointmentNotFound.vue?vue&type=script&lang=js"
export * from "./PatientAppointmentNotFound.vue?vue&type=script&lang=js"
import style0 from "./PatientAppointmentNotFound.vue?vue&type=style&index=0&id=60579d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60579d9c",
  null
  
)

export default component.exports